import styled from "styled-components";
import { Modal, Input, Select, Button } from "antd";
import { darkenHex } from "../utils";

export const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #e74c3c;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-modal-body {
    padding: 24px 24px 0 24px;
  }

  .ant-form-item-required::before {
    content: none !important;
  }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }
`;

export const ButtonSend = styled(Button)<{ backgroundColor: string }>`
  border-radius: 8px;
  background: ${({ backgroundColor }) => backgroundColor};
  border-color: ${({ backgroundColor }) => backgroundColor};
  
  &:hover {
    border-color: ${({ backgroundColor }) => backgroundColor};
    background-color: ${({ backgroundColor }) => darkenHex(backgroundColor)} !important;
  }

`;

export const Textarea = styled(Input.TextArea)`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 100%;
  height: 80px;
  padding: 10px;

  &:hover, &:active {
    border-color: #40a9ff;
    border-right-width: 1px !important;
  }
`;

export const SelectAntd = styled(Select)`
  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }
`;